import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_UPDATE_SUPPORTERS_REDESIGN = defineFcm(
	'starter_experience_dashboard_update_supporters_redesign',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_dashboard_update_supporters_redesign',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description: 'Controls the visibility of the redesigned Update Supporters (Post an Update) feature.',
		template: {
			experimentName: 'starter_experience_dashboard_update_supporters_redesign',
			enabled: false,
		},
	});
